module.exports = __webpack_public_path__ + "loader.gif?4889784689c1b8109f97a0eecf9265f4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader.gif
// module id = 975
// module chunks = 2